import React, { useState, useEffect } from "react";
import styles from "./Contact.module.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });
  
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Add a slight delay for animation effect
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 200);
    
    // Load Google Maps script
    const loadGoogleMaps = () => {
      if (window.google) return;
      
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAp_qWvoMK6reqUfY9_0pLsfDbYcwkn_GQ&callback=initMap`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
      
      window.initMap = () => {
        const location = { lat: 7.006874, lng: 79.954331 };
        const map = new window.google.maps.Map(document.getElementById('map'), {
          zoom: 15,
          center: location,
          styles: [
            {
              "featureType": "all",
              "elementType": "geometry.fill",
              "stylers": [{"color": "#f5f1e8"}]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [{"color": "#8b7d4b"}, {"lightness": 50}]
            },
            {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [{"color": "#d9c9a3"}]
            }
          ]
        });
        
        new window.google.maps.Marker({
          position: location,
          map: map,
          title: 'ThronStone Construction',
          icon: {
            url: 'data:image/svg+xml;base64,' + btoa(`
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <circle cx="20" cy="20" r="18" fill="#8b7d4b" stroke="#27231d" stroke-width="2"/>
                <circle cx="20" cy="18" r="8" fill="#f5f1e8"/>
              </svg>
            `),
            scaledSize: new window.google.maps.Size(40, 40)
          }
        });
      };
    };
    
    loadGoogleMaps();
    
    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEmailSend = () => {
    const subject = encodeURIComponent(formData.subject || "Inquiry from ThroneStone Website");
    const body = encodeURIComponent(`Hello ThroneStone Construction,

Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Subject: ${formData.subject}

Message:
${formData.message}

Best regards,
${formData.name}`);

    const mailtoUrl = `mailto:chamarathronestone@yahoo.com?subject=${subject}&body=${body}`;
    window.location.href = mailtoUrl;
  };

  const handleWhatsAppSend = () => {
    const message = `Hello ThronStone Construction,

Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Subject: ${formData.subject}

Message: ${formData.message}

I would like to discuss this further with you.`;

    const whatsappUrl = `https://wa.me/94714785357?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className={styles.contactPage}>
      <div className={styles.galleryHeader}>
        <h1>Contact us</h1>
        <p>We are here to assist you with your architectural aspirations.</p> 
      </div>
      
      <div className={`${styles.contactContainer} ${isVisible ? styles.visible : ''}`}>
        <div className={styles.contactInfo}>
          <div className={styles.contactCard}>
            <div className={styles.cardIcon}>
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <h3>Our Office</h3>
            <p>No. 429/4, Ganemulla Road, Kadawatha, Sri Lanka</p>
            
          </div>
          
          <div className={styles.contactCard}>
            <div className={styles.cardIcon}>
              <i className="fas fa-phone-alt"></i>
            </div>
            <h3>Telephone</h3>
            <p>+94 0711155357</p>
            <p>+94 0767934836</p>
          </div>
          
          <div className={styles.contactCard}>
            <div className={styles.cardIcon}>
              <i className="fas fa-envelope"></i>
            </div>
            <h3>Post</h3>
            <p>chamarathronestone@yahoo.com</p>
     
          </div>
          
          <div className={styles.contactCard}>
            <div className={styles.cardIcon}>
              <i className="fab fa-whatsapp"></i>
            </div>
            <h3>Whatsapp</h3>
            <p>+94 0714785357</p>
            <p>Quick responses within 2 hours</p>
          </div>
        </div>
        
        <div className={styles.contactForm}>
          <h2>Request An Audience</h2>
          
          <form>
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label htmlFor="name">Your Esteemed Name</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  placeholder="Sir/Lady ........" 
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="email">Email</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  placeholder="johndoe@example.com" 
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label htmlFor="phone">Telephone Number</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone" 
                  placeholder="+94 77 123 4567" 
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="subject">Subject of Inquiry</label>
                <input 
                  type="text" 
                  id="subject" 
                  name="subject" 
                  placeholder="Commission Request" 
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            
            <div className={styles.formGroup}>
              <label htmlFor="message">Your Esteemed Message</label>
              <textarea 
                id="message" 
                name="message" 
                placeholder="Kindly detail the nature of your architectural aspirations..." 
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            
            <div className={styles.buttonGroup}>
              <button 
                type="button" 
                className={styles.submitButton}
                onClick={handleEmailSend}
                disabled={!formData.name || !formData.message}
              >
                Send Email
              </button>
              
              <button 
                type="button" 
                className={styles.whatsappButton}
                onClick={handleWhatsAppSend}
                disabled={!formData.name || !formData.message}
              >
                <i className="fab fa-whatsapp"></i>
                Send via WhatsApp
              </button>
            </div>
          </form>
        </div>
      </div>
      
      <div className={`${styles.mapSection} ${isVisible ? styles.visible : ''}`}>
        <h2>Our Grand Estate</h2>
        <div className={styles.map}>
          <div id="map" style={{ width: '100%', height: '100%' }}></div>
        </div>
      </div>
    </div>
  );
};

export default Contact;